export const abvFormat = (v) => v > 99 ? `${v}%` : `${v}%`;
export const defaultFormat = (v) => v;
